"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _TextField = _interopRequireDefault(require("../TextField"));

var _Autocomplete = _interopRequireDefault(require("./Autocomplete.proptypes"));

var _utils = require("./utils");

var _SuggestionItems = _interopRequireDefault(require("./SuggestionItems"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Autocomplete__Wrapper",
  componentId: "sc-m7rd0u-0"
})(["width:100%;display:block;position:relative;z-index:", ";"], function (_ref) {
  var zIndex = _ref.zIndex;
  return zIndex;
});

Wrapper.displayName = 'Wrapper';

var Autocomplete = function Autocomplete(props) {
  var value = props.value,
      label = props.label,
      icon = props.icon,
      disabled = props.disabled,
      accessible = props.accessible,
      validateStatus = props.validateStatus,
      validateMessage = props.validateMessage,
      selectTextOnFocus = props.selectTextOnFocus,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      onSelect = props.onSelect,
      onClick = props.onClick,
      theme = props.theme,
      customProperties = props.customProperties,
      className = props.className,
      InputComponent = props.inputComponent,
      alwaysShowLabel = props.alwaysShowLabel,
      showIconProp = props.showIcon,
      zIndex = props.zIndex,
      hideResults = props.hideResults,
      _props$items = props.items,
      items = _props$items === void 0 ? [] : _props$items,
      move = props.move;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      textValue = _useState2[0],
      setTextValue = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      selectedItems = _useState4[0],
      setSelectedItems = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showSuggestion = _useState6[0],
      setShowSuggestion = _useState6[1];

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      autoFocus = _React$useState2[0],
      setAutoFocus = _React$useState2[1];

  (0, _react.useEffect)(function () {
    setTextValue(value || '');
  }, [value]);

  var closeAllSelect = function closeAllSelect(event) {
    event.preventDefault();
    event.stopPropagation();
    setShowSuggestion(false);
    window.removeEventListener('click', closeAllSelect);
  };

  var showSuggestionPopup = function showSuggestionPopup() {
    setShowSuggestion(true);
    window.addEventListener('click', closeAllSelect);
  };

  var closeSuggestionPopup = function closeSuggestionPopup() {
    setSelectedItems([]);
    window.addEventListener('click', closeAllSelect);
  };

  var handleTextChange = function handleTextChange(event) {
    if (!hideResults) {
      var propValue = event.target.value;
      var filtered = (0, _utils.findItems)({
        queryText: propValue.trim(),
        items: items
      });
      setSelectedItems(filtered);

      if (filtered.length) {
        showSuggestionPopup();
      }
    }

    setAutoFocus(false);
    onChange(event);
  };

  var handleClick = function handleClick() {
    onClick();
  };

  var handleSelect = function handleSelect(item, index) {
    onSelect(items.find(function (_ref2) {
      var itemValue = _ref2.value;
      return item.value === itemValue;
    }), index);
    setTextValue(item.label);
    setSelectedItems([]);
    window.removeEventListener('click', closeAllSelect);
  };

  var handleKeyDown = function handleKeyDown(event) {
    switch (event.key) {
      case 'ArrowDown':
        {
          if (showSuggestion) {
            setAutoFocus(true);
          }

          break;
        }

      case 'Tab':
        closeSuggestionPopup();
        break;

      default:
        break;
    }
  };

  var textInputProps = {
    value: textValue,
    label: label,
    icon: icon,
    disabled: disabled,
    accessible: accessible,
    validateStatus: validateStatus,
    validateMessage: validateMessage,
    selectTextOnFocus: selectTextOnFocus,
    onChange: handleTextChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onClick: handleClick,
    theme: theme,
    customProperties: _objectSpread(_objectSpread({}, customProperties), {}, {
      onKeyDown: handleKeyDown
    }),
    className: className,
    inputComponent: InputComponent,
    alwaysShowLabel: alwaysShowLabel,
    showIcon: showIconProp
  };

  var getMain = function getMain() {
    var showResults = showSuggestion && selectedItems.length > 0;

    var _ref3 = customProperties || {},
        suggestionProps = _ref3.suggestionProps;

    return /*#__PURE__*/_react.default.createElement(Wrapper, {
      zIndex: zIndex
    }, /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_TextField.default, textInputProps)), !hideResults && Boolean(showResults) && /*#__PURE__*/_react.default.createElement(_SuggestionItems.default, (0, _extends2.default)({
      items: selectedItems,
      width: "100%",
      onSelect: handleSelect,
      onBlur: function onBlur() {
        return closeSuggestionPopup();
      }
    }, suggestionProps, {
      autoFocus: autoFocus,
      move: move
    })));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Autocomplete.propTypes = _Autocomplete.default.PropTypes;
Autocomplete.defaultProps = _Autocomplete.default.DefaultProps;
var _default = Autocomplete;
exports.default = _default;